/// <amd-module name="Reporting/VelocityReport/Pickers/BacklogsQuery" />
import { Backlog, BacklogsQuery } from "Analytics/Boards/BoardsQueries/BacklogsQuery";
import { ICacheableQueryService } from "Dashboards/WidgetCommon/DashboardsCacheableQueryService";
import { IVssPageContext } from "VSS/Platform/Context";
export { Backlog };

export async function getBacklog(
    pageContext: IVssPageContext,
    projectId: string,
    teamId: string,
    categoryReferenceName: string
): Promise<Backlog | undefined> {
    const queryCache = pageContext.getService<ICacheableQueryService>("IDashboardsCacheableQueryService");
    const query = new BacklogsQuery(projectId, [teamId]);
    const result = await queryCache.getCacheableQueryResult(query);

    const matchingBoardId = result.findIndex(backlog => {
        return backlog.BoardCategoryReferenceName === categoryReferenceName;
    });
    return matchingBoardId >= 0 ? result[matchingBoardId] : undefined;
}
